import { BirthdayPicker } from './FormBirthdayPicker';
import { Checkbox } from './FormCheckbox';
import { Chip, ChipMenu } from './FormChip';
import { Container } from './FormContainer';
import { Group } from './FormGroup';
import { MaskedTextField } from './FormMaskedTextField';
import { NumberField, NumberFieldWithBackground } from './FormNumberField';
import { NumberFieldCode } from './FormNumberFieldCode';
import { Picker } from './FormPicker';
import { PickersGroup } from './FormPickersGroup';
import { ResponsiveSelect } from './FormResponsiveSelect';
import { Select } from './FormSelect';
import { Stepper } from './FormStepper';
import { SubmitButton } from './FormSubmitButton';
import { Subtitle } from './FormSubtitle';
import { Switch } from './FormSwitch';
import {
  TextField,
  TextFieldPassword,
  TextFieldPhoneNumber,
  TextFieldUppercase,
  TextFieldWithBackground,
  TextFieldZipCode,
} from './FormTextField';
import { Title } from './FormTitle';

export const Form = {
  Chip: Chip,
  ChipMenu: ChipMenu,
  Container: Container,
  Group: Group,
  NumberField: NumberField,
  NumberFieldCode: NumberFieldCode,
  NumberFieldWithBackground: NumberFieldWithBackground,
  BirthdayPicker: BirthdayPicker,
  Picker: Picker,
  PickersGroup: PickersGroup,
  ResponsiveSelect: ResponsiveSelect,
  Select: Select,
  SubmitButton: SubmitButton,
  Subtitle: Subtitle,
  Stepper: Stepper,
  Switch: Switch,
  Checkbox: Checkbox,
  TextField: TextField,
  TextFieldWithBackground: TextFieldWithBackground,
  TextFieldPassword: TextFieldPassword,
  TextFieldZipCode: TextFieldZipCode,
  TextFieldUppercase: TextFieldUppercase,
  TextFieldPhoneNumber: TextFieldPhoneNumber,
  MaskedTextField: MaskedTextField,
  Title: Title,
};
